/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
	
	
	$('.toggle-nav').click(function(){
		$('.nav-primary').slideToggle(150);
	});
	
	
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


function getTimeRemaining(endtime) {
  var t = Date.parse(endtime) - Date.parse(new Date());
  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor(t / (1000 * 60 * 60 * 24));
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

function initializeClock(class, endtime) {
  var x = document.getElementsByClassName(class);
  var i;
  for (i = 0; i < x.length; i++) {
	  
	  var daysSpan = x[i].querySelector('.days');
	  var hoursSpan = x[i].querySelector('.hours');
	  var minutesSpan = x[i].querySelector('.minutes');
	  var secondsSpan = x[i].querySelector('.seconds');
  }

  function updateClock() {
	  var i;
	  for (i = 0; i < x.length; i++) {
	  
		  var daysSpan = x[i].querySelector('.days');
		  var hoursSpan = x[i].querySelector('.hours');
		  var minutesSpan = x[i].querySelector('.minutes');
		  var secondsSpan = x[i].querySelector('.seconds');
	      var t = getTimeRemaining(endtime);
	  	if(t.days<1){
	  		daysSpan.innerHTML='';
	  	}
	  	else{
	  		daysSpan.innerHTML = t.days+'<span class="clock-note">day</span>';
	  		if(t.days!=1){
	  			daysSpan.innerHTML += '<span class="clock-note">s</span>';
	  		}
	  	}
	  	if(t.days<1 && t.hours<1){
	  		hoursSpan.innerHTML = '';
	  	}
	      else{
	  		hoursSpan.innerHTML = t.hours+'<span class="clock-note  visible-xs-inline">:</span><span class="clock-note  hidden-xs">hr</span>';
	  		if(t.hours!=1){
	  			hoursSpan.innerHTML += '<span class="clock-note  hidden-xs">s</span>';
	  		}
	  	}
	
	  	if(t.days<1 && t.hours<1 && t.minutes<1){
	  		minutesSpan.innerHTML='';
	  	}
	  	else{
	  		minutesSpan.innerHTML = t.minutes+'<span class="clock-note  visible-xs-inline">:</span><span class="clock-note hidden-xs">min</span>';
	  		if(t.minutes!=1){
	  			minutesSpan.innerHTML += '<span class="clock-note hidden-xs">s</span>';
	  		}

	  	}
	
	  	secondsSpan.innerHTML = t.seconds+'<span class="clock-note hidden-xs">sec</span>';
	  	if(t.seconds!=1){
	  		secondsSpan.innerHTML += '<span class="clock-note hidden-xs">s</span>';
	  	}

	      if (t.total <= 0) {
	        clearInterval(timeinterval);
	      }
	  }
    
  }

  updateClock();
  var timeinterval = setInterval(updateClock, 1000);
}

if(deadline){
	initializeClock("clockdiv", deadline);
}





